export const getCaseGranulometryEditOtherPropertiesPropertyTriggerId = (
  caseLabel: string,
  propertyName: string
) => `case${caseLabel}EditOtherPropertiesProperty${propertyName}`;
